import { useEffect, useState } from 'react'
import Select from '../../components/select'
import { Input } from 'antd'
import './style.less'

const passportFormat = ['jpg', 'jpeg', 'png']
const imgFormat = ['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp', 'psd', 'tif']
const zipFormat = ['rar', 'zip', '7z']
const vdioFormat = ['mp4', 'avi', 'wmv', 'rmvb', 'mov']
const fileFormat = ['txt', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'wps']
const customNotAllowFormat = ['exe', 'bat', 'html', 'htm', 'shtml', 'shtm', 'js', 'css']

const fileFormatChecked = {}
let fileFormatDefault = []

/**
 * 鉴定自定义文件格式是否合法
 * @param {*} value
 * @returns
 */
export function validateCustomFileFormat(value) {
  if (!Array.isArray(value)) {
    return ''
  }
  for (let i = 0, len = value.length; i < len; i++) {
    const v = value[i]
    if (customNotAllowFormat.includes(v)) {
      return `不可定义${customNotAllowFormat.join(' ')}格式的文件`
    }
  }
  return ''
}

const UploadFormat = props => {
  const prefixCls = 'bytfc-upload-fmt'
  const { addons } = props
  const { dependValues } = addons
  const fileType = dependValues[0]
  const [options, setOptions] = useState([])
  const [value, setValue] = useState(props.value)
  const [customFormatError, setCustomFormatError] = useState('') // 自定义文件格式错误信息
  const fieldId = addons.formData.$id
  const key = `${fieldId}:${fileType}`
  if (Array.isArray(fileFormatDefault) && fileFormatDefault.length === 0) {
    fileFormatDefault = props.value
    fileFormatChecked[key] = fileFormatDefault
  }

  const setValueByPath = val => {
    const { dataPath, setValueByPath } = addons
    setValueByPath(dataPath, val)
  }

  useEffect(() => {
    let type = fileType
    if (!type) {
      type = 'passport'
    }
    if (key in fileFormatChecked && fileFormatChecked[key]) {
      setValueByPath(fileFormatChecked[key])
      setValue(fileFormatChecked[key])
      if (fileType === 'custom') {
        setCustomFormatError(validateCustomFileFormat(fileFormatChecked[key]))
      }
      return
    }
    let format = []
    switch (type) {
      case 'passport':
        format = passportFormat
        break
      case 'file':
        format = fileFormat
        break
      case 'image':
        format = imgFormat
        break
      case 'vido':
        format = vdioFormat
        break
      case 'zip':
        format = zipFormat
        break
      case 'custom':
        format = []
        if (props.value && props.value.length) {
          format = props.value
        }
        break
      default:
        break
    }
    setValueByPath(format)
    setValue(format)
    fileFormatChecked[key] = format
    if (Array.isArray(format)) {
      setOptions(
        format.map(item => {
          return { label: item, value: item }
        })
      )
    }
  }, [fileType, fieldId])

  return fileType === 'custom' ? (
    <div className={prefixCls}>
      <p className={`${prefixCls}-desc`}>可输入允许上传的格式扩展名，用逗号分隔，如txt,pdf,gif</p>
      <Input
        className={customFormatError && 'fr-item-status-error'}
        value={value.join(',')}
        onChange={e => {
          const value = e.target.value
          const list = value.split(',')
          const error = validateCustomFileFormat(list)
          if (error) {
            setCustomFormatError(error)
          } else {
            setCustomFormatError('')
          }
          setValue(list)
          setValueByPath(list)
          const key = `${fieldId}:${fileType}`
          fileFormatChecked[key] = list
        }}
      />
      {customFormatError && <p className={`${prefixCls}-error`}>{customFormatError}</p>}
    </div>
  ) : (
    <Select
      value={value}
      options={options}
      mode="multiple"
      disabled={true}
      placeholder="请选择文件格式"
      onChange={value => {
        const key = `${fieldId}:${fileType}`
        fileFormatChecked[key] = value
        setValue(value)
        setValueByPath(value)
      }}
    />
  )
}

export default UploadFormat
